import { useCallback } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import UserActionError from '@/interfaces/errors/userAction';
import { functions } from '@/config/firebase';
const PREFIX = 'common: hooks: useStripeAccount:';
const USER_MESSAGES = {
  checkoutSessionApi: 'Appologies, there was an unexpected error redirecting you to checkout, please try again or message chat for support.',
  stripeCheckoutRedirect: 'Appologies, there was an unexpected error redirecting you to checkout, please try again or message chat for support.',
  stripeBillingRedirect: 'Appologies, there was an unexpected error redirecting you to billing, please try again or message chat for support.'
};
export const ERROR_CODES = {
  checkoutSessionApi: `${PREFIX}checkoutSessionApi`,
  stripeCheckoutRedirect: `${PREFIX}stripeCheckoutRedirect`,
  stripeBillingRedirect: `${PREFIX}stripeBillingRedirect`
};
const stripePromise = loadStripe( // @ts-ignore
process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY);
export default function useStripeAccount(user) {
  // Redirect user to purchase selected subscription
  // via the the generated Stripe Checkout page
  const redirectToCheckout = useCallback(async priceId => {
    if (!user) throw Error(`${PREFIX} redirectToCheckout: invoked without user`);
    const stripeCreateCheckoutSession = functions.httpsCallable('stripeCreateCheckoutSession');
    let sessionId = '';

    try {
      var _result$data;

      const result = await stripeCreateCheckoutSession({
        email: user.email,
        priceId
      });
      if (!(result !== null && result !== void 0 && (_result$data = result.data) !== null && _result$data !== void 0 && _result$data.id)) throw Error('unexpected API response');
      sessionId = result.data.id;
    } catch (err) {
      throw createCheckoutSessionApiError(`${PREFIX} redirectToCheckout`, err); // Sentry.captureException(wrappedErr);
      // logger.error(wrappedErr);
    }

    try {
      const stripe = await stripePromise;
      if (!stripe) throw Error('Stripe failed to load'); // When the customer clicks on the button, redirect them to Checkout.

      const {
        error: err
      } = await stripe.redirectToCheckout({
        sessionId
      });
      if (err) throw err;
    } catch (err) {
      throw createStripCheckoutRedirectError(`${PREFIX} redirectToCheckout`, err);
    }
  }, [user]); // Redirect user to their billing page
  // to view details about their current
  // Stripe subscription & payment history

  const redirectToBilling = useCallback(async () => {
    if (!user) throw Error(`${PREFIX} redirectToCheckout: invoked without user`); // Call function to create the Checkout session

    const stripeCreateBillingSession = functions.httpsCallable('stripeCreateBillingSession');
    let billingUrl = '';

    try {
      var _result$data2;

      const result = await stripeCreateBillingSession();
      if (!(result !== null && result !== void 0 && (_result$data2 = result.data) !== null && _result$data2 !== void 0 && _result$data2.url)) throw Error('unexpected API response');
      billingUrl = result.data.url;
    } catch (err) {
      throw createStripBillingRedirectError(`${PREFIX} redirectToBilling`, err); // Sentry.captureException(wrappedErr);
      // logger.error(wrappedErr);
      // sendNotification({
      //   type: 'error',
      //   description: 'Appologies, there was an unexpected error redirecting you to billing, please try again or message chat for support.',
      // });
    }

    window.location.href = billingUrl;
  }, [user]);
  return {
    redirectToCheckout,
    redirectToBilling
  };
}

const createCheckoutSessionApiError = (prefix, err) => {
  const actionErr = new UserActionError(`${prefix}: failed to create checkout session: ${err}`);
  actionErr.userMessage = USER_MESSAGES.checkoutSessionApi;
  actionErr.code = ERROR_CODES.checkoutSessionApi;
  return actionErr;
};

const createStripCheckoutRedirectError = (prefix, err) => {
  const actionErr = new UserActionError(`${prefix}: failed to redirect to stripe checkout: ${err}`);
  actionErr.userMessage = USER_MESSAGES.stripeCheckoutRedirect;
  actionErr.code = ERROR_CODES.stripeCheckoutRedirect;
  return actionErr;
};

const createStripBillingRedirectError = (prefix, err) => {
  const actionErr = new UserActionError(`${prefix}: failed to redirect to stripe billing: ${err}`);
  actionErr.userMessage = USER_MESSAGES.stripeBillingRedirect;
  actionErr.code = ERROR_CODES.stripeBillingRedirect;
  return actionErr;
};